<template>
  <div class="toast">
    <div
      class="toast-content"
      :class="{
        show,
        scale,
        [position]: position,
        [positionClass]: positionClass,
      }"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "toast",
  props: {
    text: "",
    position: "",
    appender: Object,
  },
  mounted() {
    this.checkEnv();
  },
  data() {
    return {
      show: false,
      scale: true,
      positionClass: "",
    };
  },
  methods: {
    checkEnv() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        wx.miniProgram.getEnv((res) => {
          if (!res.miniprogram) {
            this.positionClass = "bottom";
          }
        });
      } else {
        this.positionClass = "bottom";
      }
    },
    open(options) {
      this.scale = true;
      this.$nextTick(() => (this.show = true));
      setTimeout(() => {
        this.appender.close();
      }, 2600);
    },
    close(callback) {
      this.scale = false;
      this.$nextTick(() => {
        this.show = false;
        setTimeout(() => {
          typeof callback === "function" && callback();
        }, 260);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/common/scss/base";
$base-size: 750;
@function pxTovw($px) {
  @return $px/$base-size * 100vw;
}

.toast-content.show {
  opacity: 1;
  visibility: visible;
}
.toast-content.bottom {
  top: auto;
  bottom: pxTovw(368);
}
.toast-content {
  position: fixed;
  left: 50%;
  top: 50%;
  max-width: pxTovw(640);
  transform: translate(-50%, -50%);
  z-index: 3001;
  height: pxTovw(96);
  line-height: pxTovw(96);
  background: rgba(34, 34, 34, 0.8);
  border-radius: pxTovw(200);
  padding: 0 pxTovw(40);
  font-size: pxTovw(28);
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  transition: all 260ms ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
